import { create } from 'zustand';

export enum NavigationLinks {
  SWAP = 'SWAP',
  EARN = 'EARN',
  HISTORY = 'HISTORY',
  BURN = 'BURN',
  PROPOSALS = 'PROPOSALS',
  STATISTICS = 'STATISTICS',
}

interface HeaderNavigationState {
  currentNav: NavigationLinks | undefined;
  setCurrentNav: (nav: NavigationLinks) => void;
}

const createNavigationStore = () => {
  return create<HeaderNavigationState>((set) => ({
    currentNav: undefined,
    setCurrentNav: (nav: NavigationLinks) => set({ currentNav: nav }),
  }));
};

export const useMainNavigationStore = createNavigationStore();
